import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faTimes } from "@fortawesome/free-solid-svg-icons";
import { Link, useLocation } from "react-router-dom"; // Import Link and useLocation for routing

const Navbar: React.FC = () => {
  // State to track whether we've scrolled past 50px
  const [scrolled, setScrolled] = useState(false);
  // State to control the mobile menu visibility
  const [navVisible, setNavVisible] = useState(false);

  // Check scroll position to toggle the scrolled class on the nav element
  const handleScroll = () => {
    if (window.scrollY > 50) {
      setScrolled(true);
    } else {
      setScrolled(false);
    }
  };

  // Ensure we hide the mobile nav for larger screens
  const handleResize = () => {
    if (window.innerWidth >= 768) {
      setNavVisible(false);
    }
  };

  // Toggle the mobile nav visibility
  const toggleNav = () => {
    setNavVisible(!navVisible);
  };

  // Hide the mobile nav
  const hideNav = () => {
    setNavVisible(false);
  };

  // Listen for route changes to hide the mobile nav
  const location = useLocation();
  useEffect(() => {
    hideNav();
  }, [location]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);

    // Initial check for window size to set nav visibility accordingly
    handleResize();

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <nav className={`${scrolled ? "scrolled" : ""}`}>
      <div className="nav-container">
        {/* Mobile navigation toggle button */}
        <button className="nav-toggle" onClick={toggleNav}>
          <FontAwesomeIcon icon={navVisible ? faTimes : faBars} />
        </button>
      </div>
      <ul className={`nav-items ${navVisible ? "nav-visible" : "nav-hidden"}`}>
        {/* Internal in-page link for the About section on the home page */}
        <li>
          <a href="/" onClick={hideNav}>
            Home
          </a>
        </li>
        {/* Link to the Experience & Education page */}
        <li>
          <Link to="/resume" onClick={hideNav}>
            Resume
          </Link>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
